<div
  class="froala-editor"
  [froalaEditor]="froalaEditor"
  [froalaModel]="froalaModel"
  (froalaModelChange)="onFroalaModelChange($event)"
></div>
